import { NgModule } from '@angular/core';

import { SplashScreenComponent } from './splash-screen.component';

import { LoadingSpinnerComponent } from 'lipp-components';
import { CommonModule } from '@angular/common';

@NgModule({
  declarations: [SplashScreenComponent],
  exports: [SplashScreenComponent],
  imports: [CommonModule, LoadingSpinnerComponent],
  providers: [],
})
export class SplashScreenModule {}
